import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AppContainer from "../Structure/AppContainer";
import RoleContext from "../../Context/RoleContext";
import CreateRole from "./CreateRole";
import useStateCallback from "../../util/customHooks/useStateCallback";
export default function RoleCards() {
  const { getRoleList, roleList } = useContext(RoleContext);
  const navigate = useNavigate();
  const goToPermissions = (role_id) => {
    navigate(`/users/roles/permissions/${role_id}`);
  };
  // Modal state
  const [createRole, setcreateRole] = useStateCallback(false);
  const handlecreateRole = (data) => {
    setcreateRole(false, () =>
      setcreateRole(<CreateRole data={data} func={getRoleList} />)
    );
  };
  // Styles
  const styles = {
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
    },
    title: {
      fontSize: "26px",
      fontWeight: "600",
      color: "#1f2937",
    },
    createBtn: {
      background: "linear-gradient(135deg, #2563eb, #3b82f6)",
      color: "#fff",
      border: "none",
      padding: "10px 20px",
      borderRadius: "12px",
      fontWeight: "600",
      fontSize: "15px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    },
    createBtnHover: {
      transform: "scale(1.05)",
      boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "25px",
    },
    card: {
      background: "rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(12px)",
      border: "1px solid rgba(255, 255, 255, 0.15)",
      borderRadius: "20px",
      boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
      padding: "30px 20px",
      textAlign: "center",
      color: "#ffffff",
      transition: "all 0.4s ease",
      backgroundImage:
        "linear-gradient(145deg, rgba(30, 60, 114, 0.85), rgba(51, 115, 226, 0.85))",
    },
    cardHover: {
      transform: "translateY(-8px)",
      boxShadow: "0 16px 30px rgba(0,0,0,0.3)",
      backgroundImage:
        "linear-gradient(145deg, rgba(51, 115, 226, 0.95), rgba(0, 212, 255, 0.95))",
    },
    cardTitle: {
      fontSize: "20px",
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    actionBtn: {
      background: "linear-gradient(135deg, #4facfe, #00f2fe)",
      border: "none",
      borderRadius: "10px",
      color: "#fff",
      fontWeight: "600",
      padding: "10px 20px",
      marginTop: "20px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    },
    actionBtnHover: {
      transform: "scale(1.05)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
    },
    emptyText: {
      textAlign: "center",
      fontSize: "18px",
      color: "#9ca3af",
      marginTop: "40px",
    },
  };
  return (
    <AppContainer title="Roles">
      {createRole}
      {/* Header */}
      <div style={styles.headerContainer}>
        <h2 style={styles.title}>Manage Roles</h2>
        <HoverButton
          baseStyle={styles.createBtn}
          hoverStyle={styles.createBtnHover}
          onClick={handlecreateRole}
          text="Create Role"
          icon="fa fa-plus"
        />
      </div>
      {/* Roles */}
      <div style={styles.grid}>
        {roleList.length > 0 ? (
          Array.isArray(roleList) &&
          roleList.map((role) => (
            <HoverCard
              key={role.role_id}
              baseStyle={styles.card}
              hoverStyle={styles.cardHover}
            >
              <h3 style={styles.cardTitle}>{role.role_name}</h3>
              <HoverButton
                baseStyle={styles.actionBtn}
                hoverStyle={styles.actionBtnHover}
                text="Allocate Permission"
                onClick={() => goToPermissions(role.role_id)}
              />
            </HoverCard>
          ))
        ) : (
          <p style={styles.emptyText}>No roles found yet.</p>
        )}
      </div>
    </AppContainer>
  );
}
/* --- Inline Hover Components --- */
// HoverCard component (adds hover effect to any div)
function HoverCard({ baseStyle, hoverStyle, children }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div
      style={hovered ? { ...baseStyle, ...hoverStyle } : baseStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </div>
  );
}
// HoverButton component (adds hover effect to buttons)
function HoverButton({ baseStyle, hoverStyle, text, onClick, icon }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <button
      style={hovered ? { ...baseStyle, ...hoverStyle } : baseStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      {icon && <i className={`${icon} me-2`}></i>}
      {text}
    </button>
  );
}
